import { Injectable } from '@angular/core';

import { CollaborationData } from '@models/CollaborationData';
import { Observable } from 'rxjs';
import { AuthService } from '@services/auth.service';
import { DbService } from '@services/db.service';

@Injectable({
  providedIn: 'root'
})
export class CollaborationService {

  STATE_WAITING = "waiting";
  STATE_SUCCEEDED = "succeeded";
  STATE_FAILED = "failed";

  currentCollaborationPath: string = null;

  constructor(
    private dbService: DbService,
    private authService: AuthService
  ) { }

  setCurrentCollaboration(collaboration: any, collaborationId: string) {
    this.currentCollaborationPath = `accounts/${this.authService.currentUser.account_id}/workflow_collaborations/${collaborationId}`;
    return this.dbService.set(`accounts/${this.authService.currentUser.account_id}/workflow_collaborations/${collaborationId}`, collaboration);
  }

  getCurrentCollaboration(collaborationId: string = null) {
    this.currentCollaborationPath = `accounts/${this.authService.currentUser.account_id}/workflow_collaborations/${collaborationId}`;
    return this.dbService.listen<CollaborationData>(this.currentCollaborationPath)
  }

  removeCurrentCollaboration(collaborationId: string) {
    return this.dbService.remove(`accounts/${this.authService.currentUser.account_id}/workflow_collaborations/${collaborationId}`);
  }

  createCollaboration(key: string, name: string, url: string) {
    const uid = this.authService.currentUser.id;
    const uname = this.authService.currentUser.name;
    const collaboration = {
      collaboration_data: {
        type: "image",
        key: key,
        name: name,
        annotating: true,
        status: {
          [uid]: {
            state: "waiting",
            name: uname
          },
          ["dummy"]: {
            state: "succeeded",
            name: ""
          }
        },
        url: url
      },
      controls: {
        zoom_ratio: 1.0,
        pdf_scroll_ratio: 0,
        pdf_current_page: 1,
        polar_angle: 0,
        azimuthal_angle: 0,
        final_polar_angle: 0,
        final_azimuthal_angle: 0,
        hide:true,
        close:false,
        page_ratio: 0,
        x: 0.5,
        y: 0.5,
        z: 1,
        refresh: "no",
        revert: "no"
      }
    };
    return collaboration;
  }

  getCollaborationData(id: string = null): Observable<CollaborationData> {
    const path = this.currentCollaborationPath + '/collaboration_data';
    return this.dbService.listen<CollaborationData>(path);
  }

  toggleAnnotate(annotating: boolean){
    this.dbService.update(this.currentCollaborationPath + '/collaboration_data', {annotating: annotating});
  }

  // methods for remote synchronization
  setCollaborationLoaded() { return new Promise<void>(resolve => resolve()) }
  closeCollaboration() { return new Promise<boolean>(resolve => resolve(true)) }
}